export function env(name: string): string {
  const envVariable = process.env[name];

  if (envVariable !== undefined) {
    return envVariable;
  }

  return '';
}
